import T from "./abi.js";
import E from "./address.js";
const N = {
  ADEPTUS: {
    CLAIM_REWARD: {
      abi: T.ADEPTUS,
      address: E.ADEPTUS,
      method: "claimRewards"
    }
  },
  APOSTLE: {
    _INFO: {
      abi: T.APOSTLE.INFO,
      address: E.APOSTLE,
      method: ""
    },
    GET_USER_ALLOWANCE: {
      abi: T.APOSTLE.INFO,
      address: E.APOSTLE,
      method: "isApprovedForAll"
    },
    REQUEST_ALLOWANCE: {
      abi: T.APOSTLE.INFO,
      address: E.APOSTLE,
      method: "setApprovalForAll"
    },
    SAFE_TRANSFER_FROM: {
      abi: T.APOSTLE.INFO,
      // godiverse abi = astronomical abi
      address: E.APOSTLE,
      method: "safeTransferFrom"
    },
    MINT_SEASON_CALLER: {
      abi: T.APOSTLE.MINT,
      address: E.APOSTLE_SEASON_CALLER,
      // minting for "reserved apostle" or "origin apostle ticket"
      method: "requestMultiSeasonPurchase"
    },
    MINT_TICKET: {
      abi: T.APOSTLE_TICKET.MINT,
      address: E.APOSTLE_TICKET,
      method: "requestTicketMinting"
    },
    GET_MINTING_STRUCT: {
      abi: T.APOSTLE_TICKET.MINT,
      address: E.APOSTLE_TICKET,
      method: "getTicketMintingStructsByRequestId"
    },
    MANAGE_PLANET_APOSTLES: {
      abi: T.APOSTLE.MANAGE,
      address: E.APOSTLE_MANAGE,
      method: "manageRelicApostles"
    }
  },
  APOSTLE_FORGE: {
    RESET_TIME_INTERVAL: {
      abi: T.APOSTLE.FORGE,
      address: E.APOSTLE_FORGE,
      method: "forgeStageResetTime"
    },
    NFT_PLANET_STAGE_INFO: {
      abi: T.APOSTLE.FORGE,
      address: E.APOSTLE_FORGE,
      method: "planetLastForgeStageDataMapping"
    },
    SEED_PLANET_STAGE_INFO: {
      abi: T.APOSTLE.FORGE,
      address: E.APOSTLE_FORGE,
      method: "seedPlanetLastForgeStageDataMapping"
    },
    FORGE_RESERVED_APOSTLE: {
      abi: T.APOSTLE.FORGE,
      address: E.APOSTLE_FORGE,
      method: "forgeReservedApostle"
    }
  },
  APOSTLE_SPIRITUAL_MERGE: {
    GET_SM_PROGRESS: {
      abi: T.APOSTLE.EXTENSION,
      address: E.APOSTLE_EXTENSION,
      method: "getApostleDataAndSMProgress"
    },
    GET_TARGET_PROGRESS: {
      abi: T.APOSTLE.SPIRITUAL_MERGE,
      address: E.APOSTLE_SPIRITUAL_MERGE,
      method: "calcTargetIvAndProgress"
    },
    SPIRITUAL_MERGE: {
      abi: T.APOSTLE.SPIRITUAL_MERGE,
      address: E.APOSTLE_SPIRITUAL_MERGE,
      method: "spiritualMerge"
    }
  },
  BATTLE_DEMO: {
    BURN_TIME: {
      abi: T.BATTLE_DEMO.BURN_TIME,
      address: E.BATTLE_DEMO_BURN_TIME,
      method: "burnToken"
    },
    FRAGMENT: {
      abi: T.BATTLE_DEMO.FRAGMENT,
      address: E.FRAGMENT,
      method: "balanceOfBatch"
    },
    GET_ALLOWANCE: {
      abi: T.BATTLE_DEMO.FRAGMENT,
      address: E.FRAGMENT,
      method: "isApprovedForAll"
    },
    REQUEST_ALLOWANCE: {
      abi: T.BATTLE_DEMO.FRAGMENT,
      address: E.FRAGMENT,
      method: "setApprovalForAll"
    }
  },
  BLANK: {
    abi: {
      POLYGON: [],
      RONIN: []
    },
    address: {
      POLYGON: "",
      RONIN: ""
    },
    method: ""
  },
  BRIDGE_BURNER: {
    BURN_ASSET: {
      abi: T.BRIDGE.BURN,
      address: E.BRIDGE_BURNER,
      method: "burnAsset"
    }
  },
  BRIDGE_MINTER: {
    MINT_STAR: {
      abi: T.BRIDGE.MINT,
      address: E.BRIDGE_MINTER,
      method: "mintStar"
    },
    MINT_GODIVERSE: {
      abi: T.BRIDGE.MINT,
      address: E.BRIDGE_MINTER,
      method: "mintGodiverse"
    },
    MINT_PLANET: {
      abi: T.BRIDGE.MINT,
      address: E.BRIDGE_MINTER,
      method: "mintPlanet"
    },
    MINT_APOSTLE: {
      abi: T.BRIDGE.MINT,
      address: E.BRIDGE_MINTER,
      method: "mintApostle"
    }
  },
  BOUNTY: {
    APOSTLE: {
      CREATE_BOUNTY: {
        abi: T.BOUNTY.APOSTLE,
        address: E.BOUNTY.APOSTLE,
        method: "createBounty"
      },
      FULFILL_BOUNTY: {
        abi: T.BOUNTY.APOSTLE,
        address: E.BOUNTY.APOSTLE,
        method: "fulfillBounty"
      },
      CANCEL_BOUNTY: {
        abi: T.BOUNTY.APOSTLE,
        address: E.BOUNTY.APOSTLE,
        method: "cancelBounty"
      }
    }
  },
  CURRENCY: {
    ANIMA: {
      GET_PLANET_PRICE: {
        abi: T.PLANET.BREED,
        address: E.BREED,
        method: "animaPrices"
      },
      GET_PLANET_PRICE_FOR_PRIMEVAL: {
        abi: T.PLANET.BREED,
        address: E.BREED,
        method: "primevalAnimaPrices"
      },
      GET_USER_ALLOWANCE: {
        abi: T.CURRENCY.ANIMA,
        address: E.ANIMA,
        method: "allowance"
      },
      GET_USER_BALANCE: {
        abi: T.CURRENCY.ANIMA,
        address: E.ANIMA,
        method: "balanceOf"
      },
      REQUEST_ALLOWANCE: {
        abi: T.CURRENCY.ANIMA,
        address: E.ANIMA,
        method: "approve"
      }
    },
    APRS: {
      GET_PLANET_PRICE: {
        abi: T.PLANET.BREED,
        address: E.BREED,
        method: "aprsPrices"
      },
      GET_PLANET_PRICE_FOR_PRIMEVAL: {
        abi: T.PLANET.BREED,
        address: E.BREED,
        method: "primevalAprsPrices"
      },
      GET_USER_ALLOWANCE: {
        abi: T.CURRENCY.APRS,
        address: E.APRS,
        method: "allowance"
      },
      GET_USER_BALANCE: {
        abi: T.CURRENCY.APRS,
        address: E.APRS,
        method: "balanceOf"
      },
      REQUEST_ALLOWANCE: {
        abi: T.CURRENCY.APRS,
        address: E.APRS,
        method: "approve"
      }
    },
    WETH: {
      _INFO: {
        abi: T.CURRENCY.WETH,
        address: E.WETH,
        method: ""
      },
      GET_USER_ALLOWANCE: {
        abi: T.CURRENCY.WETH,
        address: E.WETH,
        method: "allowance"
      },
      GET_USER_BALANCE: {
        abi: T.CURRENCY.WETH,
        address: E.WETH,
        method: "balanceOf"
      },
      REQUEST_ALLOWANCE: {
        abi: T.CURRENCY.WETH,
        address: E.WETH,
        method: "approve"
      }
    },
    USDC: {
      GET_USER_ALLOWANCE: {
        abi: T.CURRENCY.USDC,
        address: E.USDC,
        method: "allowance"
      },
      GET_USER_BALANCE: {
        abi: T.CURRENCY.USDC,
        address: E.USDC,
        method: "balanceOf"
      },
      REQUEST_ALLOWANCE: {
        abi: T.CURRENCY.USDC,
        address: E.USDC,
        method: "approve"
      }
    },
    WRON: {
      GET_USER_ALLOWANCE: {
        abi: T.CURRENCY.WRON,
        address: E.WRON,
        method: "allowance"
      },
      GET_USER_BALANCE: {
        abi: T.CURRENCY.WRON,
        address: E.WRON,
        method: "balanceOf"
      },
      REQUEST_ALLOWANCE: {
        abi: T.CURRENCY.WRON,
        address: E.WRON,
        method: "approve"
      }
    },
    APRS_WRON: {
      GET_USER_ALLOWANCE: {
        abi: T.CURRENCY.APRS_WRON,
        address: E.APRS_WRON,
        method: "allowance"
      },
      GET_USER_BALANCE: {
        abi: T.CURRENCY.APRS_WRON,
        address: E.APRS_WRON,
        method: "balanceOf"
      },
      REQUEST_ALLOWANCE: {
        abi: T.CURRENCY.APRS_WRON,
        address: E.APRS_WRON,
        method: "approve"
      },
      GET_RESERVES: {
        abi: T.CURRENCY.APRS_WRON,
        address: E.APRS_WRON,
        method: "getReserves"
      },
      GET_TOTAL_SUPPLY: {
        abi: T.CURRENCY.APRS_WRON,
        address: E.APRS_WRON,
        method: "totalSupply"
      }
    },
    ANIMA_WRON: {
      GET_USER_ALLOWANCE: {
        abi: T.CURRENCY.ANIMA_WRON,
        address: E.ANIMA_WRON,
        method: "allowance"
      },
      GET_USER_BALANCE: {
        abi: T.CURRENCY.ANIMA_WRON,
        address: E.ANIMA_WRON,
        method: "balanceOf"
      },
      REQUEST_ALLOWANCE: {
        abi: T.CURRENCY.ANIMA_WRON,
        address: E.ANIMA_WRON,
        method: "approve"
      },
      GET_RESERVES: {
        abi: T.CURRENCY.ANIMA_WRON,
        address: E.ANIMA_WRON,
        method: "getReserves"
      },
      GET_TOTAL_SUPPLY: {
        abi: T.CURRENCY.ANIMA_WRON,
        address: E.ANIMA_WRON,
        method: "totalSupply"
      }
    }
  },
  CURRENCY_CONVERTER: {
    CONVERT_TOKEN: {
      abi: T.TOKEN_CONVERTER,
      address: E.TOKEN_CONVERTER,
      method: "convertToken"
    }
  },
  CONJUNCT: {
    BLACK_HOLE: {
      GET_ID: {
        abi: T.PLANET.BREED,
        address: E.BREED,
        method: "miniBlackholeTokenId"
      },
      GET_PLANET_PRICE: {
        abi: T.PLANET.BREED,
        address: E.BREED,
        method: "apeironGodiverseCollectionNumbers"
      },
      GET_PLANET_PRICE_FOR_PRIMEVAL: {
        abi: T.PLANET.BREED,
        address: E.BREED,
        method: "primevalApeironGodiverseCollectionNumbers"
      },
      GET_USER_ALLOWANCE: {
        abi: T.GODIVERSE,
        address: E.GODIVERSE,
        method: "isApprovedForAll"
      },
      GET_USER_BALANCE: {
        abi: T.GODIVERSE,
        address: E.GODIVERSE,
        method: "balanceOf"
      },
      REQUEST_ALLOWANCE: {
        abi: T.GODIVERSE,
        address: E.GODIVERSE,
        method: "setApprovalForAll"
      }
    },
    CHECK_BREED: {
      abi: T.PLANET.BREED,
      address: E.BREED,
      method: "BreedStructMap"
    },
    REQUEST_BREED: {
      abi: T.PLANET.BREED,
      address: E.BREED,
      method: "requestBreedWithAnimus"
    }
  },
  DAILY_CHECK_IN: {
    CHECK_IN: {
      abi: T.DAILY_CHECK_IN,
      address: E.DAILY_CHECK_IN,
      method: "dailyCheckin"
    },
    GET_MAKE_UP_PRICE: {
      abi: T.DAILY_CHECK_IN,
      address: E.DAILY_CHECK_IN,
      method: "makeupPricesArray"
    },
    MAKE_UP_CHECK_IN: {
      abi: T.DAILY_CHECK_IN,
      address: E.DAILY_CHECK_IN,
      method: "makeupCheckin"
    }
  },
  DOODIPALS: {
    DOODINOMICS: {
      abi: T.DOODIPALS.DOODINOMICS,
      address: E.DOODIPALS_DOODINOMICS,
      method: "doodinomics"
    }
  },
  EXPEDITION: {
    // Black Hole + Support Apostle Ticket
    TYPE1: {
      CLAIM_REWARD: {
        abi: T.EXPEDITION.TYPE1.PRIZE,
        address: E.EXPEDITION.TYPE1.PRIZES,
        method: "claimTreasure"
      },
      GET_CURRENCY_ADDRESS: {
        abi: T.EXPEDITION.TYPE1.KEY,
        address: E.EXPEDITION.TYPE1.STAKING_AND_KEYS,
        method: "exchangeToken"
      },
      GET_EXPEDITION_STATUS: {
        abi: T.EXPEDITION.TYPE1.INFO,
        address: E.EXPEDITION.TYPE1.INFO,
        method: "getExpeditionState"
      },
      GET_KEY_BALANCE: {
        abi: T.EXPEDITION.TYPE1.KEY,
        address: E.EXPEDITION.TYPE1.STAKING_AND_KEYS,
        method: "userKeys"
      },
      GET_KEY_EXCHANGE_RATE: {
        abi: T.EXPEDITION.TYPE1.KEY,
        address: E.EXPEDITION.TYPE1.STAKING_AND_KEYS,
        method: "exchangeRateForKey"
      },
      GET_ALL_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE1.KEY,
        address: E.EXPEDITION.TYPE1.STAKING_AND_KEYS,
        method: "getAllStakedAssets"
      },
      GET_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE1.KEY,
        address: E.EXPEDITION.TYPE1.STAKING_AND_KEYS,
        method: "getStakedAssets"
      },
      GET_USER_EXPEDITION: {
        abi: T.EXPEDITION.TYPE1.INFO,
        address: E.EXPEDITION.TYPE1.INFO,
        method: "getUserExpedition"
      },
      JOIN_EXPEDITION: {
        abi: T.EXPEDITION.TYPE1.INFO,
        address: E.EXPEDITION.TYPE1.INFO,
        method: "joinExpedition"
      },
      REQUEST_KEY_TO_TOKEN: {
        abi: T.EXPEDITION.TYPE1.INFO,
        address: E.EXPEDITION.TYPE1.INFO,
        method: "exchangeKeyToToken"
      },
      REQUEST_STAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE1.INFO,
        address: E.EXPEDITION.TYPE1.INFO,
        method: "stakeNFT"
      },
      REQUEST_STAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE1.INFO,
        address: E.EXPEDITION.TYPE1.INFO,
        method: "stakeFT"
      },
      REQUEST_TOKEN_TO_KEY: {
        abi: T.EXPEDITION.TYPE1.INFO,
        address: E.EXPEDITION.TYPE1.INFO,
        method: "exchangeTokenToKey"
      },
      REQUEST_UNSTAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE1.INFO,
        address: E.EXPEDITION.TYPE1.INFO,
        method: "unstakeNFT"
      },
      REQUEST_UNSTAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE1.INFO,
        address: E.EXPEDITION.TYPE1.INFO,
        method: "unstakeFT"
      }
    },
    // Star + Astro + Support Apostle Ticket
    TYPE2: {
      CLAIM_REWARD: {
        abi: T.EXPEDITION.TYPE1.PRIZE,
        address: E.EXPEDITION.TYPE2.PRIZES,
        method: "claimTreasure"
      },
      GET_CURRENCY_ADDRESS: {
        abi: T.EXPEDITION.TYPE2.KEY,
        address: E.EXPEDITION.TYPE2.STAKING_AND_KEYS,
        method: "exchangeToken"
      },
      GET_EXPEDITION_STATUS: {
        abi: T.EXPEDITION.TYPE2.INFO,
        address: E.EXPEDITION.TYPE2.INFO,
        method: "getExpeditionState"
      },
      GET_KEY_BALANCE: {
        abi: T.EXPEDITION.TYPE2.KEY,
        address: E.EXPEDITION.TYPE2.STAKING_AND_KEYS,
        method: "userKeys"
      },
      GET_KEY_EXCHANGE_RATE: {
        abi: T.EXPEDITION.TYPE2.KEY,
        address: E.EXPEDITION.TYPE2.STAKING_AND_KEYS,
        method: "exchangeRateForKey"
      },
      GET_ALL_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE2.KEY,
        address: E.EXPEDITION.TYPE2.STAKING_AND_KEYS,
        method: "getAllStakedAssets"
      },
      GET_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE2.KEY,
        address: E.EXPEDITION.TYPE2.STAKING_AND_KEYS,
        method: "getStakedAssets"
      },
      GET_USER_EXPEDITION: {
        abi: T.EXPEDITION.TYPE2.INFO,
        address: E.EXPEDITION.TYPE2.INFO,
        method: "getUserExpedition"
      },
      JOIN_EXPEDITION: {
        abi: T.EXPEDITION.TYPE2.INFO,
        address: E.EXPEDITION.TYPE2.INFO,
        method: "joinExpedition"
      },
      REQUEST_KEY_TO_TOKEN: {
        abi: T.EXPEDITION.TYPE2.INFO,
        address: E.EXPEDITION.TYPE2.INFO,
        method: "exchangeKeyToToken"
      },
      REQUEST_STAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE2.INFO,
        address: E.EXPEDITION.TYPE2.INFO,
        method: "stakeNFT"
      },
      REQUEST_STAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE2.INFO,
        address: E.EXPEDITION.TYPE2.INFO,
        method: "stakeFT"
      },
      REQUEST_TOKEN_TO_KEY: {
        abi: T.EXPEDITION.TYPE2.INFO,
        address: E.EXPEDITION.TYPE2.INFO,
        method: "exchangeTokenToKey"
      },
      REQUEST_UNSTAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE2.INFO,
        address: E.EXPEDITION.TYPE2.INFO,
        method: "unstakeNFT"
      },
      REQUEST_UNSTAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE2.INFO,
        address: E.EXPEDITION.TYPE2.INFO,
        method: "unstakeFT"
      }
    },
    // Emblem + Support Apostle Ticket
    TYPE3: {
      CLAIM_REWARD: {
        abi: T.EXPEDITION.TYPE3.PRIZE,
        address: E.EXPEDITION.TYPE3.PRIZES,
        method: "claimTreasure"
      },
      GET_CURRENCY_ADDRESS: {
        abi: T.EXPEDITION.TYPE3.KEY,
        address: E.EXPEDITION.TYPE3.STAKING_AND_KEYS,
        method: "exchangeToken"
      },
      GET_EXPEDITION_STATUS: {
        abi: T.EXPEDITION.TYPE3.INFO,
        address: E.EXPEDITION.TYPE3.INFO,
        method: "getExpeditionState"
      },
      GET_KEY_BALANCE: {
        abi: T.EXPEDITION.TYPE3.KEY,
        address: E.EXPEDITION.TYPE3.STAKING_AND_KEYS,
        method: "userKeys"
      },
      GET_KEY_EXCHANGE_RATE: {
        abi: T.EXPEDITION.TYPE3.KEY,
        address: E.EXPEDITION.TYPE3.STAKING_AND_KEYS,
        method: "exchangeRateForKey"
      },
      GET_ALL_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE3.KEY,
        address: E.EXPEDITION.TYPE3.STAKING_AND_KEYS,
        method: "getAllStakedAssets"
      },
      GET_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE3.KEY,
        address: E.EXPEDITION.TYPE3.STAKING_AND_KEYS,
        method: "getStakedAssets"
      },
      GET_USER_EXPEDITION: {
        abi: T.EXPEDITION.TYPE3.INFO,
        address: E.EXPEDITION.TYPE3.INFO,
        method: "getUserExpedition"
      },
      JOIN_EXPEDITION: {
        abi: T.EXPEDITION.TYPE3.INFO,
        address: E.EXPEDITION.TYPE3.INFO,
        method: "joinExpedition"
      },
      REQUEST_KEY_TO_TOKEN: {
        abi: T.EXPEDITION.TYPE3.INFO,
        address: E.EXPEDITION.TYPE3.INFO,
        method: "exchangeKeyToToken"
      },
      REQUEST_STAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE3.INFO,
        address: E.EXPEDITION.TYPE3.INFO,
        method: "stakeNFT"
      },
      REQUEST_STAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE3.INFO,
        address: E.EXPEDITION.TYPE3.INFO,
        method: "stakeFT"
      },
      REQUEST_TOKEN_TO_KEY: {
        abi: T.EXPEDITION.TYPE3.INFO,
        address: E.EXPEDITION.TYPE3.INFO,
        method: "exchangeTokenToKey"
      },
      REQUEST_UNSTAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE3.INFO,
        address: E.EXPEDITION.TYPE3.INFO,
        method: "unstakeNFT"
      },
      REQUEST_UNSTAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE3.INFO,
        address: E.EXPEDITION.TYPE3.INFO,
        method: "unstakeFT"
      }
    },
    // Emblem + Support Apostle Stake
    TYPE4: {
      CLAIM_REWARD: {
        abi: T.EXPEDITION.TYPE4.PRIZE,
        address: E.EXPEDITION.TYPE4.PRIZES,
        method: "claimTreasure"
      },
      GET_CURRENCY_ADDRESS: {
        abi: T.EXPEDITION.TYPE4.KEY,
        address: E.EXPEDITION.TYPE4.STAKING_AND_KEYS,
        method: "exchangeToken"
      },
      GET_EXPEDITION_STATUS: {
        abi: T.EXPEDITION.TYPE4.INFO,
        address: E.EXPEDITION.TYPE4.INFO,
        method: "getExpeditionState"
      },
      GET_KEY_BALANCE: {
        abi: T.EXPEDITION.TYPE4.KEY,
        address: E.EXPEDITION.TYPE4.STAKING_AND_KEYS,
        method: "userKeys"
      },
      GET_KEY_EXCHANGE_RATE: {
        abi: T.EXPEDITION.TYPE4.KEY,
        address: E.EXPEDITION.TYPE4.STAKING_AND_KEYS,
        method: "exchangeRateForKey"
      },
      GET_ALL_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE4.KEY,
        address: E.EXPEDITION.TYPE4.STAKING_AND_KEYS,
        method: "getAllStakedAssets"
      },
      GET_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE4.KEY,
        address: E.EXPEDITION.TYPE4.STAKING_AND_KEYS,
        method: "getStakedAssets"
      },
      GET_USER_EXPEDITION: {
        abi: T.EXPEDITION.TYPE4.INFO,
        address: E.EXPEDITION.TYPE4.INFO,
        method: "getUserExpedition"
      },
      JOIN_EXPEDITION: {
        abi: T.EXPEDITION.TYPE4.INFO,
        address: E.EXPEDITION.TYPE4.INFO,
        method: "joinExpedition"
      },
      REQUEST_KEY_TO_TOKEN: {
        abi: T.EXPEDITION.TYPE4.INFO,
        address: E.EXPEDITION.TYPE4.INFO,
        method: "exchangeKeyToToken"
      },
      REQUEST_STAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE4.INFO,
        address: E.EXPEDITION.TYPE4.INFO,
        method: "stakeNFT"
      },
      REQUEST_STAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE4.INFO,
        address: E.EXPEDITION.TYPE4.INFO,
        method: "stakeFT"
      },
      REQUEST_TOKEN_TO_KEY: {
        abi: T.EXPEDITION.TYPE4.INFO,
        address: E.EXPEDITION.TYPE4.INFO,
        method: "exchangeTokenToKey"
      },
      REQUEST_UNSTAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE4.INFO,
        address: E.EXPEDITION.TYPE4.INFO,
        method: "unstakeNFT"
      },
      REQUEST_UNSTAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE4.INFO,
        address: E.EXPEDITION.TYPE4.INFO,
        method: "unstakeFT"
      }
    },
    // Off Chain Reward + Support Apostle Stake
    TYPE5: {
      CLAIM_REWARD: {
        abi: T.EXPEDITION.TYPE5.PRIZE,
        address: E.EXPEDITION.TYPE5.PRIZES,
        method: "claimTreasure"
      },
      GET_CURRENCY_ADDRESS: {
        abi: T.EXPEDITION.TYPE5.KEY,
        address: E.EXPEDITION.TYPE5.STAKING_AND_KEYS,
        method: "exchangeToken"
      },
      GET_EXPEDITION_STATUS: {
        abi: T.EXPEDITION.TYPE5.INFO,
        address: E.EXPEDITION.TYPE5.INFO,
        method: "getExpeditionState"
      },
      GET_KEY_BALANCE: {
        abi: T.EXPEDITION.TYPE5.KEY,
        address: E.EXPEDITION.TYPE5.STAKING_AND_KEYS,
        method: "userKeys"
      },
      GET_KEY_EXCHANGE_RATE: {
        abi: T.EXPEDITION.TYPE5.KEY,
        address: E.EXPEDITION.TYPE5.STAKING_AND_KEYS,
        method: "exchangeRateForKey"
      },
      GET_ALL_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE5.KEY,
        address: E.EXPEDITION.TYPE5.STAKING_AND_KEYS,
        method: "getAllStakedAssets"
      },
      GET_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE5.KEY,
        address: E.EXPEDITION.TYPE5.STAKING_AND_KEYS,
        method: "getStakedAssets"
      },
      GET_USER_EXPEDITION: {
        abi: T.EXPEDITION.TYPE5.INFO,
        address: E.EXPEDITION.TYPE5.INFO,
        method: "getUserExpedition"
      },
      JOIN_EXPEDITION: {
        abi: T.EXPEDITION.TYPE5.INFO,
        address: E.EXPEDITION.TYPE5.INFO,
        method: "joinExpedition"
      },
      REQUEST_KEY_TO_TOKEN: {
        abi: T.EXPEDITION.TYPE5.INFO,
        address: E.EXPEDITION.TYPE5.INFO,
        method: "exchangeKeyToToken"
      },
      REQUEST_STAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE5.INFO,
        address: E.EXPEDITION.TYPE5.INFO,
        method: "stakeNFT"
      },
      REQUEST_STAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE5.INFO,
        address: E.EXPEDITION.TYPE5.INFO,
        method: "stakeFT"
      },
      REQUEST_TOKEN_TO_KEY: {
        abi: T.EXPEDITION.TYPE5.INFO,
        address: E.EXPEDITION.TYPE5.INFO,
        method: "exchangeTokenToKey"
      },
      REQUEST_UNSTAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE5.INFO,
        address: E.EXPEDITION.TYPE5.INFO,
        method: "unstakeNFT"
      },
      REQUEST_UNSTAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE5.INFO,
        address: E.EXPEDITION.TYPE5.INFO,
        method: "unstakeFT"
      }
    },
    // On Chain Reward (Animus) + Support Apostle Stake
    TYPE6: {
      CLAIM_REWARD: {
        abi: T.EXPEDITION.TYPE6.PRIZE,
        address: E.EXPEDITION.TYPE6.PRIZES,
        method: "claimTreasure"
      },
      GET_CURRENCY_ADDRESS: {
        abi: T.EXPEDITION.TYPE6.KEY,
        address: E.EXPEDITION.TYPE6.STAKING_AND_KEYS,
        method: "exchangeToken"
      },
      GET_EXPEDITION_STATUS: {
        abi: T.EXPEDITION.TYPE6.INFO,
        address: E.EXPEDITION.TYPE6.INFO,
        method: "getExpeditionState"
      },
      GET_KEY_BALANCE: {
        abi: T.EXPEDITION.TYPE6.KEY,
        address: E.EXPEDITION.TYPE6.STAKING_AND_KEYS,
        method: "userKeys"
      },
      GET_KEY_EXCHANGE_RATE: {
        abi: T.EXPEDITION.TYPE6.KEY,
        address: E.EXPEDITION.TYPE6.STAKING_AND_KEYS,
        method: "exchangeRateForKey"
      },
      GET_ALL_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE6.KEY,
        address: E.EXPEDITION.TYPE6.STAKING_AND_KEYS,
        method: "getAllStakedAssets"
      },
      GET_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE6.KEY,
        address: E.EXPEDITION.TYPE6.STAKING_AND_KEYS,
        method: "getStakedAssets"
      },
      GET_USER_EXPEDITION: {
        abi: T.EXPEDITION.TYPE6.INFO,
        address: E.EXPEDITION.TYPE6.INFO,
        method: "getUserExpedition"
      },
      JOIN_EXPEDITION: {
        abi: T.EXPEDITION.TYPE6.INFO,
        address: E.EXPEDITION.TYPE6.INFO,
        method: "joinExpedition"
      },
      REQUEST_KEY_TO_TOKEN: {
        abi: T.EXPEDITION.TYPE6.INFO,
        address: E.EXPEDITION.TYPE6.INFO,
        method: "exchangeKeyToToken"
      },
      REQUEST_STAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE6.INFO,
        address: E.EXPEDITION.TYPE6.INFO,
        method: "stakeNFT"
      },
      REQUEST_STAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE6.INFO,
        address: E.EXPEDITION.TYPE6.INFO,
        method: "stakeFT"
      },
      REQUEST_TOKEN_TO_KEY: {
        abi: T.EXPEDITION.TYPE6.INFO,
        address: E.EXPEDITION.TYPE6.INFO,
        method: "exchangeTokenToKey"
      },
      REQUEST_UNSTAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE6.INFO,
        address: E.EXPEDITION.TYPE6.INFO,
        method: "unstakeNFT"
      },
      REQUEST_UNSTAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE6.INFO,
        address: E.EXPEDITION.TYPE6.INFO,
        method: "unstakeFT"
      }
    },
    // On Chain Reward (Star) + Support Apostle Stake
    TYPE7: {
      CLAIM_REWARD: {
        abi: T.EXPEDITION.TYPE7.PRIZE,
        address: E.EXPEDITION.TYPE7.PRIZES,
        method: "claimTreasure"
      },
      GET_CURRENCY_ADDRESS: {
        abi: T.EXPEDITION.TYPE7.KEY,
        address: E.EXPEDITION.TYPE7.STAKING_AND_KEYS,
        method: "exchangeToken"
      },
      GET_EXPEDITION_STATUS: {
        abi: T.EXPEDITION.TYPE7.INFO,
        address: E.EXPEDITION.TYPE7.INFO,
        method: "getExpeditionState"
      },
      GET_KEY_BALANCE: {
        abi: T.EXPEDITION.TYPE7.KEY,
        address: E.EXPEDITION.TYPE7.STAKING_AND_KEYS,
        method: "userKeys"
      },
      GET_KEY_EXCHANGE_RATE: {
        abi: T.EXPEDITION.TYPE7.KEY,
        address: E.EXPEDITION.TYPE7.STAKING_AND_KEYS,
        method: "exchangeRateForKey"
      },
      GET_ALL_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE7.KEY,
        address: E.EXPEDITION.TYPE7.STAKING_AND_KEYS,
        method: "getAllStakedAssets"
      },
      GET_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE7.KEY,
        address: E.EXPEDITION.TYPE7.STAKING_AND_KEYS,
        method: "getStakedAssets"
      },
      GET_USER_EXPEDITION: {
        abi: T.EXPEDITION.TYPE7.INFO,
        address: E.EXPEDITION.TYPE7.INFO,
        method: "getUserExpedition"
      },
      JOIN_EXPEDITION: {
        abi: T.EXPEDITION.TYPE7.INFO,
        address: E.EXPEDITION.TYPE7.INFO,
        method: "joinExpedition"
      },
      REQUEST_KEY_TO_TOKEN: {
        abi: T.EXPEDITION.TYPE7.INFO,
        address: E.EXPEDITION.TYPE7.INFO,
        method: "exchangeKeyToToken"
      },
      REQUEST_STAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE7.INFO,
        address: E.EXPEDITION.TYPE7.INFO,
        method: "stakeNFT"
      },
      REQUEST_STAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE7.INFO,
        address: E.EXPEDITION.TYPE7.INFO,
        method: "stakeFT"
      },
      REQUEST_TOKEN_TO_KEY: {
        abi: T.EXPEDITION.TYPE7.INFO,
        address: E.EXPEDITION.TYPE7.INFO,
        method: "exchangeTokenToKey"
      },
      REQUEST_UNSTAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE7.INFO,
        address: E.EXPEDITION.TYPE7.INFO,
        method: "unstakeNFT"
      },
      REQUEST_UNSTAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE7.INFO,
        address: E.EXPEDITION.TYPE7.INFO,
        method: "unstakeFT"
      }
    },
    // Support Axie Stake
    TYPE8: {
      CLAIM_REWARD: {
        abi: T.EXPEDITION.TYPE8.PRIZE,
        address: E.EXPEDITION.TYPE8.PRIZES,
        method: "claimTreasure"
      },
      GET_CURRENCY_ADDRESS: {
        abi: T.EXPEDITION.TYPE8.KEY,
        address: E.EXPEDITION.TYPE8.STAKING_AND_KEYS,
        method: "exchangeToken"
      },
      GET_EXPEDITION_STATUS: {
        abi: T.EXPEDITION.TYPE8.INFO,
        address: E.EXPEDITION.TYPE8.INFO,
        method: "getExpeditionState"
      },
      GET_KEY_BALANCE: {
        abi: T.EXPEDITION.TYPE8.KEY,
        address: E.EXPEDITION.TYPE8.STAKING_AND_KEYS,
        method: "userKeys"
      },
      GET_KEY_EXCHANGE_RATE: {
        abi: T.EXPEDITION.TYPE8.KEY,
        address: E.EXPEDITION.TYPE8.STAKING_AND_KEYS,
        method: "exchangeRateForKey"
      },
      GET_ALL_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE8.KEY,
        address: E.EXPEDITION.TYPE8.STAKING_AND_KEYS,
        method: "getAllStakedAssets"
      },
      GET_STAKED_ASSETS: {
        abi: T.EXPEDITION.TYPE8.KEY,
        address: E.EXPEDITION.TYPE8.STAKING_AND_KEYS,
        method: "getStakedAssets"
      },
      GET_USER_EXPEDITION: {
        abi: T.EXPEDITION.TYPE8.INFO,
        address: E.EXPEDITION.TYPE8.INFO,
        method: "getUserExpedition"
      },
      JOIN_EXPEDITION: {
        abi: T.EXPEDITION.TYPE8.INFO,
        address: E.EXPEDITION.TYPE8.INFO,
        method: "joinExpedition"
      },
      REQUEST_KEY_TO_TOKEN: {
        abi: T.EXPEDITION.TYPE8.INFO,
        address: E.EXPEDITION.TYPE8.INFO,
        method: "exchangeKeyToToken"
      },
      REQUEST_STAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE8.INFO,
        address: E.EXPEDITION.TYPE8.INFO,
        method: "stakeNFT"
      },
      REQUEST_STAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE8.INFO,
        address: E.EXPEDITION.TYPE8.INFO,
        method: "stakeFT"
      },
      REQUEST_TOKEN_TO_KEY: {
        abi: T.EXPEDITION.TYPE8.INFO,
        address: E.EXPEDITION.TYPE8.INFO,
        method: "exchangeTokenToKey"
      },
      REQUEST_UNSTAKE_ASSETS: {
        abi: T.EXPEDITION.TYPE8.INFO,
        address: E.EXPEDITION.TYPE8.INFO,
        method: "unstakeNFT"
      },
      REQUEST_UNSTAKE_EXTRA_TOKEN: {
        abi: T.EXPEDITION.TYPE8.INFO,
        address: E.EXPEDITION.TYPE8.INFO,
        method: "unstakeFT"
      }
    }
  },
  GODIVERSE: {
    _INFO: {
      abi: T.GODIVERSE,
      address: E.GODIVERSE,
      method: ""
    },
    GET_USER_ALLOWANCE: {
      abi: T.GODIVERSE,
      address: E.GODIVERSE,
      method: "isApprovedForAll"
    },
    REQUEST_ALLOWANCE: {
      abi: T.GODIVERSE,
      address: E.GODIVERSE,
      method: "setApprovalForAll"
    },
    SAFE_TRANSFER_FROM: {
      abi: T.GODIVERSE,
      // godiverse abi = astronomical abi
      address: E.GODIVERSE,
      method: "safeTransferFrom"
    }
  },
  LIQUIDITY_POOL: {
    QUOTE: {
      abi: T.LIQUIDITY.PERMISSIONED_ROUTER,
      address: E.LIQUIDITY_POOL.PERMISSIONED_ROUTER,
      method: "quote"
    },
    ADD_LIQUIDITY_RON: {
      abi: T.LIQUIDITY.PERMISSIONED_ROUTER,
      address: E.LIQUIDITY_POOL.PERMISSIONED_ROUTER,
      method: "addLiquidityRON"
    },
    REMOVE_LIQUIDITY_RON: {
      abi: T.LIQUIDITY.PERMISSIONED_ROUTER,
      address: E.LIQUIDITY_POOL.PERMISSIONED_ROUTER,
      method: "removeLiquidityRON"
    }
  },
  // for ronin
  MARKETPLACE: {
    MAKER_NONCE: {
      abi: T.MARKETPLACE.APEIRON_MARKETPLACE_GATEWAY_PROXY,
      address: E.APEIRON_MARKETPLACE_GATEWAY_PROXY,
      method: "getMakerNonce"
    },
    GET_STATE: {
      abi: T.MARKETPLACE.APEIRON_MARKETPLACE_GATEWAY_PROXY,
      address: E.APEIRON_MARKETPLACE_GATEWAY_PROXY,
      method: "getState"
    },
    GATEWAY_INTERACT_WITH: {
      abi: T.MARKETPLACE.MARKET_GATEWAY_PROXY,
      address: E.MARKET_GATEWAY_PROXY,
      method: "interactWith"
    }
  },
  // for polygon
  MARKETPLACE_721: {
    BUY: {
      abi: T.MARKETPLACE.MKTP721,
      address: E.MARKETPLACE_721,
      method: "buyAuctionItem"
    },
    CANCEL_LISTING: {
      abi: T.MARKETPLACE.MKTP721,
      address: E.MARKETPLACE_721,
      method: "cancelAuctionListing"
    },
    CREATE_LISTING: {
      abi: T.MARKETPLACE.MKTP721,
      address: E.MARKETPLACE_721,
      method: "listAuctionItem"
    },
    GET_PRICE_FOR_AUCTION: {
      abi: T.MARKETPLACE.MKTP721,
      address: E.MARKETPLACE_721,
      method: "getAuctionItemPrice"
    },
    UPDATE_LISTING: {
      abi: T.MARKETPLACE.MKTP721,
      address: E.MARKETPLACE_721,
      method: "updateAuctionItem"
    }
  },
  // for polygon
  MARKETPLACE_1155: {
    BUY: {
      abi: T.MARKETPLACE.MKTP1155,
      address: E.MARKETPLACE_1155,
      method: "buyAuctionItem"
    },
    CANCEL_LISTING: {
      abi: T.MARKETPLACE.MKTP1155,
      address: E.MARKETPLACE_1155,
      method: "cancelAuctionListing"
    },
    CREATE_LISTING: {
      abi: T.MARKETPLACE.MKTP1155,
      address: E.MARKETPLACE_1155,
      method: "listAuctionItem"
    },
    UPDATE_LISTING: {
      abi: T.MARKETPLACE.MKTP1155,
      address: E.MARKETPLACE_1155,
      method: "updateAuctionItem"
    }
  },
  MORPH: {
    CHECK_BORN: {
      abi: T.PLANET.BORN,
      address: E.BORN,
      method: "BornStructMap"
    },
    REQUEST_BORN: {
      abi: T.PLANET.BORN,
      address: E.BORN,
      method: "requestBorn"
    }
  },
  PLANET: {
    _INFO: {
      abi: T.PLANET.INFO,
      address: E.PLANET,
      method: ""
    },
    GET_USER_ALLOWANCE: {
      abi: T.PLANET.INFO,
      address: E.PLANET,
      method: "isApprovedForAll"
    },
    REQUEST_ALLOWANCE: {
      abi: T.PLANET.INFO,
      address: E.PLANET,
      method: "setApprovalForAll"
    },
    SAFE_TRANSFER_FROM: {
      abi: T.PLANET.INFO,
      address: E.PLANET,
      method: "safeTransferFrom"
    },
    CHRONOMERGE: {
      abi: T.PLANET.CHRONOMERGE,
      address: E.CHRONOMERGE,
      method: "planetChronomerging"
    }
  },
  PRELOAD: {
    GET_BLACK_HOLE_TOKEN_ID: {
      abi: T.PLANET.BREED,
      address: E.BREED,
      method: "miniBlackholeTokenId"
    },
    GET_BREED_IS_PRIMEVAL: {
      abi: T.PLANET.BREED,
      address: E.BREED,
      method: "isPrimevalActive"
    },
    GET_BREED_TIME_LIMIT: {
      abi: T.PLANET.BREED,
      address: E.BREED,
      method: "normalBreedBaseInterval"
    }
  },
  STAR: {
    _INFO: {
      abi: T.STAR.INFO,
      address: E.STAR,
      method: ""
    },
    ATTACH_GODIVERSE: {
      abi: T.STAR.ATTACH_GODIVERSE,
      address: E.STAR_ATTACH,
      method: "attachAndDetachGodiverses"
    },
    GET_USER_ALLOWANCE: {
      abi: T.PLANET.INFO,
      address: E.STAR,
      method: "isApprovedForAll"
    },
    REQUEST_ALLOWANCE: {
      abi: T.PLANET.INFO,
      address: E.STAR,
      method: "setApprovalForAll"
    },
    SAFE_TRANSFER_FROM: {
      abi: T.STAR.INFO,
      address: E.STAR,
      method: "safeTransferFrom"
    },
    OWNER_ATTACH_PLANET: {
      abi: T.ORBITAL_TRACK.CALLER,
      address: E.STAR_ORBITAL_TRACK_CALLER,
      method: "starOwnerAttachOwnPlanet"
    },
    OWNER_DETACH_PLANET: {
      abi: T.ORBITAL_TRACK.CALLER,
      address: E.STAR_ORBITAL_TRACK_CALLER,
      method: "starOwnerDetachPlanet"
    },
    RENTER_ATTACH_PLANET: {
      abi: T.ORBITAL_TRACK.CALLER,
      address: E.STAR_ORBITAL_TRACK_CALLER,
      method: "rentingOrbitalTrack",
      spenderAddress: E.STAR_ORBITAL_TRACK
    },
    RENTER_DETACH_PLANET: {
      abi: T.ORBITAL_TRACK.CALLER,
      address: E.STAR_ORBITAL_TRACK_CALLER,
      method: "planetOwnerDetachPlanet"
    },
    RENEW_RENTAL: {
      abi: T.ORBITAL_TRACK.CALLER,
      address: E.STAR_ORBITAL_TRACK_CALLER,
      method: "renewRentingOrbitalTrack"
    },
    SAVE_RENTAL_SETTING: {
      abi: T.ORBITAL_TRACK.INFO,
      address: E.STAR_ORBITAL_TRACK,
      method: "updateRentalSetting"
    }
  },
  TICKET: {
    ORIGINAL_APOSTLE_TICKET: {
      GET_USER_TICKETS: {
        abi: T.APOSTLE_TICKET.ORIGIN,
        address: E.TICKET.ORIGIN_APOSTLE,
        method: "balanceOfBatch"
      },
      GET_USER_ALLOWANCE: {
        abi: T.APOSTLE_TICKET.ORIGIN,
        address: E.TICKET.ORIGIN_APOSTLE,
        method: "isApprovedForAll"
      },
      REQUEST_ALLOWANCE: {
        abi: T.APOSTLE_TICKET.ORIGIN,
        address: E.TICKET.ORIGIN_APOSTLE,
        method: "setApprovalForAll"
      }
    },
    S2_APOSTLE_TICKET: {
      GET_USER_TICKETS: {
        abi: T.GODIVERSE,
        address: E.GODIVERSE,
        method: "balanceOfBatch"
      },
      GET_USER_ALLOWANCE: {
        abi: T.APOSTLE_TICKET.S2,
        address: E.TICKET.S2_APOSTLE,
        method: "isApprovedForAll"
      },
      REQUEST_ALLOWANCE: {
        abi: T.APOSTLE_TICKET.S2,
        address: E.TICKET.S2_APOSTLE,
        method: "setApprovalForAll"
      }
    }
  },
  THIRD_PARTY_NFT: {
    GET_USER_ALLOWANCE: {
      abi: T.PLANET.INFO,
      address: E.THIRD_PARTY_NFT,
      method: "isApprovedForAll"
    },
    REQUEST_ALLOWANCE: {
      abi: T.PLANET.INFO,
      address: E.THIRD_PARTY_NFT,
      method: "setApprovalForAll"
    },
    SAFE_TRANSFER_FROM: {
      abi: T.THIRD_PARTY_NFT,
      address: E.THIRD_PARTY_NFT,
      method: "safeTransferFrom"
    }
  },
  VESTING: {
    CLAIM: {
      abi: T.REWARD.VESTING,
      address: E.VESTING,
      method: "release"
    },
    GET_CLAIMABLE_AND_CLAIMED: {
      abi: T.REWARD.VESTING,
      address: E.VESTING,
      method: "getAccountClaimableAndReleasedAmount"
    },
    GET_VESTED: {
      abi: T.REWARD.VESTING,
      address: E.VESTING,
      method: "getAccountTotalAmount"
    }
  },
  VIP: {
    TOKEN_STAKING: {
      abi: T.VIP.TOKEN_STAKING,
      address: E.VIP_STAKING,
      method: "stakeToken"
    },
    UNSTAKE_TOKEN: {
      abi: T.VIP.TOKEN_STAKING,
      address: E.VIP_STAKING,
      method: "unstakeToken"
    }
  },
  VIP_SHOP: {
    PURCHASE: {
      abi: T.VIP.VIP_SHOP.PURCHASE,
      address: E.VIP_SHOP.PURCHASE,
      method: "purchaseItem"
    }
  }
};
export {
  N as default
};
//# sourceMappingURL=config.js.map
